module.exports = __webpack_public_path__ + "img/gift4-01-c04-t2.6e2bc9db.png";